import { useMutation, useQueryClient } from "react-query";
import { supportWidgetApi } from "@circle-react/api/supportWidgetApi";

export const useCreateConversation = ({
  onSuccess,
  onError,
  source,
  chatBotSessionId,
}) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ text, area, type, priority }) =>
      supportWidgetApi
        .createConversation({
          text,
          area,
          type,
          priority,
          source,
          chatBotSessionId,
          zendeskUploadIds: [],
          submitPageUrl: window.location.href,
          viewportHeight:
            window.innerHeight || document.documentElement.clientHeight,
          viewportWidth:
            window.innerWidth || document.documentElement.clientWidth,
        })
        .then(response => response.json()),
    {
      onSuccess: data => {
        if (queryClient.getQueryData(["conversations", "list"])) {
          queryClient.setQueryData(
            ["conversations", "list"],
            oldConversations => ({
              conversations: [data.ticket, ...oldConversations.conversations],
            }),
          );
        }

        onSuccess(data.ticket);
      },
      onError: onError,
    },
  );
};

export const useCreateChatMessage = ({ onSuccess, onError }) =>
  useMutation(
    ({ message, sessionId, productArea }) =>
      supportWidgetApi
        .createChatMessage({
          message,
          sessionId,
          productArea,
        })
        .then(response => response.json()),
    {
      onSuccess,
      onError,
    },
  );
